import { getUrlParam } from './params';

const STORAGE_KEY = 'mlabs_mcp_oauth_params';

/**
 * Params sent by mlabs_full McpOauthController when the user is not logged in:
 *   /accounts/sign_in?mcp_auth_request_id=...&mcp_callback_url=...
 *
 * After login we must resume the bridge at:
 *   {FULL_URL}/mcp/oauth/authorize?auth_request_id=...
 * so the cookie authApiToken is read and the MCP OAuth callback completes.
 */
export const persistMcpOAuthParams = () => {
  const authRequestId = getUrlParam('mcp_auth_request_id');
  const callbackUrl = getUrlParam('mcp_callback_url');

  if (!authRequestId) {
    return getStoredMcpOAuthParams();
  }

  const params = {
    authRequestId,
    ...(callbackUrl ? { callbackUrl } : {}),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  } catch {
    /* ignore quota / private mode */
  }

  return params;
};

export const getStoredMcpOAuthParams = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed?.authRequestId) return {};
    return parsed;
  } catch {
    return {};
  }
};

export const clearMcpOAuthParams = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const getMcpAuthRequestId = () => {
  const fromUrl = getUrlParam('mcp_auth_request_id');
  if (fromUrl) {
    persistMcpOAuthParams();
    return fromUrl;
  }
  return getStoredMcpOAuthParams().authRequestId;
};

/**
 * Callback URL sent to auth_api and used after login.
 * When connecting MCP (ChatGPT etc.), resume the mlabs_full OAuth bridge
 * instead of landing on the main app.
 */
export const getLoginCallbackUrl = (defaultUrl) => {
  const fallback = defaultUrl || process.env.REACT_APP_FULL_URL;
  const authRequestId = getMcpAuthRequestId();
  if (!authRequestId) {
    return fallback;
  }

  const base = (process.env.REACT_APP_FULL_URL || fallback || '').replace(/\/$/, '');
  if (!base) {
    return fallback;
  }

  return `${base}/mcp/oauth/authorize?auth_request_id=${encodeURIComponent(authRequestId)}`;
};
